import React, { PropTypes } from 'react';

import { border,
  button,
  checkedStyle,
  choice as choiceStyle,
  radioButton,
} from './styles.module.css';

const RadioButtonSwitch = ({
  choices,
  name,
  onChange,
  value,
}) => (
  <div className={border}>
    {choices.map(choice => (
      <div className={choice.value === value ? checkedStyle : choiceStyle} key={choice.id}>
        <label htmlFor={`${name}-${choice.id}`}>
          <input
            className={radioButton}
            type="radio"
            id={`${name}-${choice.id}`}
            name={name}
            onChange={onChange}
            checked={choice.value === value}
            value={choice.value}
          />
          <div className={button}>{choice.label || choice.id}</div>
        </label>
      </div>
    ))}
  </div>
);

export default RadioButtonSwitch;


RadioButtonSwitch.propTypes = {
  choices: PropTypes.arrayOf(PropTypes.shape()),
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.number,
};

RadioButtonSwitch.defaultProps = {
  choices: [],
  name: '',
  onChange: undefined,
  value: undefined,
};



// WEBPACK FOOTER //
// ./app/src/components/RadioButtonSwitch/index.jsx